import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UncontrolledCollapse } from "reactstrap";
import { FaServer, FaPlusCircle } from "react-icons/fa";

import WebAddLocalSite from "./WebAddLocalSite";
import WebLocalSiteList from "./list/WebLocalSiteList";
import WebPagination from "../etc/WebPagination";

const WebLocalSiteConfig = ({ list_configLocalSite, handleSelectedFunc }) => {
    const { t } = useTranslation();

    // 한 페이지에 보여줄 개수 (10/20/30/50/100 선택 가능)
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [offset, setOffset] = useState((page - 1) * limit);
    const [blockNum, setBlockNum] = useState(0);

    // 컴포넌트 초기 로드 여부를 추적하는 상태 추가
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const [isAddLocalSiteOK, setIsAddLocalSiteOK] = useState(false);

    useEffect(() => {
        // console.log("WebLocalSiteConfig visible");

        handleSelectedFunc({ selectedFunc: "GET_LOCAL_SITE_LIST" });

        return () => {
            // console.log("WebLocalSiteConfig invisible");

            // 컴포넌트가 언마운트될 때 초기화
            setIsFirstLoad(true);
        }
    }, []);

    useEffect(() => {
        let offset = (page - 1) * limit;
        setOffset(offset);
    }, [page, limit]);

    useEffect(() => {
        setIsAddLocalSiteOK(true);

        // 초기 로드 시에만 페이지를 1로 설정하고, 이후에는 현재 페이지 유지
        if (isFirstLoad) {
            setPage(1);
            setOffset((page - 1) * limit);
            setIsFirstLoad(false);
        }

        /* return () => {
            setPage(1);
            setOffset((page - 1) * limit);
        } */
    }, [list_configLocalSite, page, isFirstLoad]);

    const onChangeIsAddLocalSiteOK = () => {
        setIsAddLocalSiteOK(!isAddLocalSiteOK);
    }

    return (
        // teacher/class 탭과 동일한 app-container / main-title-bar / btn-top-register 스타일 적용
        // (기존 로직·핸들러·props는 그대로 유지, 마크업/className만 교체)
        <div className="web-main admin list-area">
            <div className="app-container">
                <div className="main-title-bar">
                    <div className="title-left">
                        <FaServer className="icon-teacher" aria-hidden="true" />
                        <span className="title-text">{t("로컬_사이트", { ns: "admin" })}</span>
                        <button type="button" className="btn-top-register" id="addLocalSite">
                            <FaPlusCircle aria-hidden="true" />{t("로컬_사이트_등록", { ns: "admin" })}
                        </button>
                    </div>
                </div>
                <UncontrolledCollapse toggler="#addLocalSite" defaultOpen={false}>
                    <WebAddLocalSite
                        isAddLocalSiteOK={isAddLocalSiteOK}
                        onChangeIsAddLocalSiteOK={onChangeIsAddLocalSiteOK}
                        handleSelectedFunc={handleSelectedFunc}
                    />
                </UncontrolledCollapse>
                <WebPagination
                    total={list_configLocalSite.length <= 0 ? 1 : list_configLocalSite.length}
                    limit={limit}
                    setLimit={setLimit}
                    page={page}
                    setPage={setPage}
                    blockNum={blockNum}
                    setBlockNum={setBlockNum}
                />
                <WebLocalSiteList
                    // list_localSite={list_configLocalSite}
                    list_localSite={list_configLocalSite.slice(offset, offset + limit)}
                    handleSelectedFunc={handleSelectedFunc}
                />
            </div>
        </div>
    );
}

export default WebLocalSiteConfig;
